import { render, staticRenderFns } from "./EmoteView.vue?vue&type=template&id=0c7b7d45&scoped=true&"
import script from "./EmoteView.vue?vue&type=script&lang=js&"
export * from "./EmoteView.vue?vue&type=script&lang=js&"
import style0 from "./EmoteView.vue?vue&type=style&index=0&id=0c7b7d45&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7b7d45",
  null
  
)

export default component.exports